import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../../firebase/firebase";

import {
    CLOUDINARY_URL,
    UPLOAD_PRESET
} from "../../services/cloudinary";

import "../../assets/css/admin/addGallerycategory.css";

function AddGalleryCategory() {

    const navigate = useNavigate();

    const [title, setTitle] = useState("");

    const [image, setImage] = useState(null);

    const [preview, setPreview] = useState("");

    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState({
    title: "",
    image: ""
});
const [popup, setPopup] = useState({
    show: false,
    type: "",
    message: ""
});

    const handleImageChange = (e) => {

        const file = e.target.files[0];

        if (!file) return;

        setImage(file);

        setPreview(URL.createObjectURL(file));

    };

    const uploadImage = async () => {

        const formData = new FormData();

        formData.append("file", image);

        formData.append("upload_preset", UPLOAD_PRESET);

        const response = await fetch(CLOUDINARY_URL, {

            method: "POST",

            body: formData

        });

        const data = await response.json();

        if (!response.ok) {

            throw new Error(data.error?.message || "Image Upload Failed");

        }

        return data.secure_url;

    };

    const handleSubmit = async (e) => {

        e.preventDefault();
const validationErrors = {};

if (!title.trim()) {

    validationErrors.title =
        "Gallery category is required.";

}

if (!image) {

    validationErrors.image =
        "Cover image is required.";

}

if (Object.keys(validationErrors).length > 0) {

    setErrors(validationErrors);

    return;

}

setErrors({});

        try {

            setLoading(true);

            const imageUrl = await uploadImage();

            await addDoc(collection(db, "gallery_categories"), {

                title,

                coverImage: imageUrl,

                createdAt: serverTimestamp()

            });

            setPopup({
    show: true,
    type: "success",
    message: "Gallery Category Added Successfully"
});

setTimeout(() => {

    navigate("/admin/gallery-categories");

}, 2000);

         

        }

        catch (error) {

            console.log(error);

           setPopup({
    show: true,
    type: "error",
    message: "Failed to add gallery category"
});

setTimeout(() => {

    setPopup({
        show: false,
        type: "",
        message: ""
    });

}, 3000);

        }

        finally {

            setLoading(false);

        }

    };

    return (
   <>
          {popup.show && (

    <div className={`luxury-popup ${popup.type}`}>

        <div className="popup-icon">

            {popup.type === "success" ? "✓" : "✕"}

        </div>

        <div className="popup-content">

            <h3>

                {popup.type === "success"
                    ? "Success"
                    : "Error"}

            </h3>

            <p>{popup.message}</p>

        </div>

    </div>

)}
        <div className="add-gallery-category-page">

            <div className="add-gallery-card">

                <h1>Add Gallery Card</h1>

                <form onSubmit={handleSubmit}>

                    <div className="form-group">

                        <label>Gallery Category</label>

                        <input
                            type="text"
                            placeholder="Wedding"
                            value={title}
                            onChange={(e) => {

    setTitle(e.target.value);

    setErrors({
        ...errors,
        title: ""
    });

}}
/>
{errors.title && (

    <p className="validation-error">

        {errors.title}

    </p>

)}

                    </div>

                    <div className="form-group">

                        <label>Cover Image</label>

                        <input
                            type="file"
                            accept="image/*"
                            onChange={handleImageChange}
                        />
{errors.image && (

    <p className="validation-error">

        {errors.image}

    </p>

)}
                    </div>

                    {preview && (

                        <div className="preview-container">

                            <img
                                src={preview}
                                alt="Preview"
                                className="preview-image"
                            />

                        </div>

                    )}

                    <button
                        type="submit"
                        className="save-btn"
                        disabled={loading}
                    >

                        {loading
                            ? "Uploading..."
                            : "Save Gallery Card"}

                    </button>

                </form>

            </div>

        </div>
     </>
    );

}

export default AddGalleryCategory;